import * as React from 'react';
import { Book } from '../../../../types/Book';
import { CardsManagerCallbacks } from '../../../CardsManager/CardsManager';
import Button from '../../../Button/Button';
import BookDialogPreview from '../../../BookDialogPreview/BookDialogPreview';

interface Props {
	book: Book;
	callbacks: CardsManagerCallbacks;
}

const Control: React.FC<Props> = ({ book, callbacks }) => {
	const [open, setOpen] = React.useState(false);

	const onClick = () => {
		setOpen(true);
	}

	const onClose = () => {
		setOpen(false);
	}

	return <>
		{book.cardId ? <Button onClick={onClick}>В вашей библиотеке</Button> :
			<Button onClick={onClick} type="primary">Добавить в библиотеку</Button>
		}

		{open && <BookDialogPreview
			bookExternalId={book.externalId}
			onClose={onClose}
			onSaved={onClose}
			saveCard={callbacks.addCard}
			saveProperties={callbacks.saveCardProperties}
		/>}
	</>;
};


export default Control;
